<ng-container
    *im2mLet="{
        loading: loading$ | async,
        count: availableDevicesCount$ | async,
        devices: availableDevices$ | async,
        page: page$ | async,
        currentDevice: currentDevice$ | async,
        selectedSearchOption: selectedSearchOption$ | async
    } as data"
>
    <mat-form-field appearance="outline" class="left-input">
        <mat-select [value]="data?.selectedSearchOption" (selectionChange)="onChangeSearchOptions($event.value, data?.currentDevice)">
            <mat-option *ngFor="let option of searchOptions" [value]="option">
                {{ 'DEVICE_SEARCH.' + option | transloco }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field class="right-input" appearance="outline">
        <!-- <mat-label>{{ label || 'DEVICE_SEARCH.LABEL' | transloco }}</mat-label> -->
        <input
            matInput
            class="filter-input"
            [formControl]="filterStringCtrl"
            [matMenuTriggerFor]="menu"
            #menuTrigger="matMenuTrigger"
            (click)="onFocus(menuTrigger)"
            (keydown)="openMenu(menuTrigger)"
        />

        <mat-menu #menu class="search-result-list-menu-container">
            <div class="available-user">
                <h3 class="list-title">{{ 'DEVICE_SEARCH.AVAILABLE_DEVICES' | transloco }}</h3>
                <div class="table-container" (click)="$event.stopPropagation()">
                    <liebherr-dialog-loading *ngIf="data?.loading"></liebherr-dialog-loading>
                    <table mat-table [dataSource]="data?.devices">
                        <ng-container *ngFor="let column of columns" [matColumnDef]="column">
                            <th mat-header-cell *matHeaderCellDef>
                                {{ 'DEVICE_SEARCH.' + (column | uppercase) | transloco }}
                            </th>
                            <td mat-cell class="selectable" *matCellDef="let element" (click)="onSelection(element, menuTrigger)">
                                {{ element[column] }}
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
                        <tr mat-row *matRowDef="let row; columns: columns"></tr>
                    </table>
                    <liebherr-no-data *ngIf="data?.count === 0 && !data?.loading"></liebherr-no-data>
                </div>
                <mat-paginator
                    #paginator
                    (click)="$event.stopPropagation()"
                    [pageSizeOptions]="[5]"
                    [pageSize]="5"
                    (page)="onPage($event)"
                    [pageIndex]="data?.page"
                    [length]="data?.count"
                ></mat-paginator>
            </div>
        </mat-menu>
    </mat-form-field>
    <mat-error *ngIf="filterStringCtrl.hasError('firmware')">
        {{ 'DEVICE_SEARCH.NOT_FOUND_ERROR' | transloco }}
    </mat-error>
</ng-container>
